import React, { forwardRef } from "react";
import { cn } from "@/lib/utils";

export const EntityInput = forwardRef<HTMLTextAreaElement, React.TextareaHTMLAttributes<HTMLTextAreaElement>>(
    ({ className, ...props }, ref) => {
        return <textarea ref={ref} className={cn("w-full", className)} {...props} />;
    }
);

EntityInput.displayName = "EntityInput";
